import {createUseStyles} from "react-jss";
import {Theme} from '@octavius-rocks/ui'

export const useStyles = createUseStyles({
    root: {
    },
    filters: {
        paddingBottom: 40,
    },
    filterTaxonomies: {
        marginBottom: 10,
    },
    filterTime: {
        marginBottom: 10,
    },
    lists: {
        display: "flex",
    },
    list: {
        flexGrow: 1,
    },
    listItem: {
        marginBottom: 16,
    },
    listItemDescription: {
        fontSize: "1.1rem",
        lineHeight: "1.6rem",
        marginBottom: 6,
    },
    taxonomy: {
        color: "rgba(0,0,0, 0.4)",
    },
    chartBackground: {
        height: 10,
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    chartValue: {
        height: 10,
        backgroundColor: "rgb(0, 157, 156)",
    }
});
